import settings from './settings/index.js';


import * as es from "./es";


// ######## ELASTICSEARCH ########

const ELASTICSEARCH_ITEM_INDEX = `${settings.ELASTICSEARCH_URL}/item`;


const ELASTICSEARCH = (data, mode) => {
    return fetch(`${ELASTICSEARCH_ITEM_INDEX}/${mode}`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': settings.ELASTICSEARCH_AUTH, 
        },
        
        body: JSON.stringify(data),
    }).then(response => response.json());
}

export const itemQuery = (itemId) => {
    return ELASTICSEARCH({ query: { ids: { values: [itemId] } }, size: 1 }, "_search")
        .then(data => {
            const hit = data.hits?.hits?.[0];
            if (!hit) return { found: false, item: null };
            return { found: true, item: hit._source };
        });
}

export const itemCount = (params = {}) => {
    const query = es.countQuery(params);
    return ELASTICSEARCH(query, "_count").then(data => data.count);
}

export const listQuery = (params, searchAfter = null) => {

    const query = es.listQuery(params);

    if (searchAfter) {
        query["search_after"] = searchAfter._sort;
    }

    return ELASTICSEARCH(query, "_search").then(data => {

        let items = [];
        for (let item of data.hits.hits) {
            // check ItemHeader, this is being used there.
            item._source['mainLocation'] = item.inner_hits ? item.inner_hits.locations.hits.hits[0]._source : null;

            item._source.highlight = {}
            if (item.highlight) {
                for (const key in item.highlight) {
                    item._source.highlight[key] = item.highlight[key][0];
                }
            }
            items.push({...item._source, _sort: item.sort});
        }

        return {
            items: items,
            total: data.hits.total.value
        }
    });

}

export const clusterQuery = (params) => {
    const query = es.clusterQuery(params);
    return ELASTICSEARCH(query, "_search").then(data => data.aggregations.location.polygons.clusters.buckets);
}


// ######## API ########

const API = {
    get: (url, config = {}) => {
        const options = {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...config.headers
            }
        };
        return fetch(`${settings.API_URL}${url}`, options)
            .then(response => {
                if (!response.ok) {
                    const error = new Error('HTTP Error');
                    error.response = { status: response.status };
                    throw error;
                }
                return response.json();
            })
            .then(data => ({ data }));
    },
    post: (url, data, config = {}) => {
        const isFormData = data instanceof FormData;
        const options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                ...config.headers
            },
            body: isFormData ? data : JSON.stringify(data)
        };
        return fetch(`${settings.API_URL}${url}${config.params ? '?' + new URLSearchParams(config.params) : ''}`, options)
            .then(response => {
                if (!response.ok) {
                    const error = new Error('HTTP Error');
                    error.response = { status: response.status };
                    throw error;
                }
                return response.json();
            })
            .then(data => ({ data }));
    },
    put: (url, data, config = {}) => {
        const options = {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...config.headers
            },
            body: JSON.stringify(data)
        };
        return fetch(`${settings.API_URL}${url}${config.params ? '?' + new URLSearchParams(config.params) : ''}`, options)
            .then(response => {
                if (!response.ok) {
                    const error = new Error('HTTP Error');
                    error.response = { status: response.status };
                    throw error;
                }
                return response.json();
            })
            .then(data => ({ data }));
    },
    delete: (url, config = {}) => {
        const options = {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...config.headers
            }
        };
        return fetch(`${settings.API_URL}${url}${config.params ? '?' + new URLSearchParams(config.params) : ''}`, options)
            .then(response => {
                if (!response.ok) {
                    const error = new Error('HTTP Error');
                    error.response = { status: response.status };
                    throw error;
                }
                return response.json();
            })
            .then(data => ({ data }));
    }
};



